import React from 'react'
import { Button, Modal } from 'react-bootstrap'

const DeleteAppointmentModal = ({show, setShow,onConfirm, data}) => {
    // console.log(data);

    const handleClose = () => setShow(false);

    return (
        <Modal show={show} onHide={handleClose} centered>
            <Modal.Header closeButton>
                <Modal.Title>Cancel Appointment </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <h6>Are you sure you want to cancel Appointment?</h6>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="primary" onClick={onConfirm}>
                    Yes! Cancel
                </Button>
                <Button variant="secondary" onClick={()=>handleClose()}>
                    Close
                </Button>
            </Modal.Footer>
        </Modal>
    )
}

export default DeleteAppointmentModal
